function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.18 3.82c-.604 0-1.23.205-1.711.633v.024l-.024.023-8.765 8.695c-.909.909-.903 2.388-.047 3.352l.023.023h.024l4.5 4.5c.454.454 1.06.674 1.664.68H21v-1.5h-8.625l7.875-7.875c.95-.95.979-2.467.07-3.375l-4.5-4.5a2.294 2.294 0 00-1.64-.68zm-.024 1.524c.24 0 .463.064.61.21l4.5 4.5c.29.29.33.865-.07 1.266l-3.774 3.774L9.68 9.352l3.797-3.774.023-.023c.19-.159.428-.211.656-.211zM8.602 10.43l5.742 5.742-3.82 3.82c-.01.006-.015.018-.024.024-.387.322-.981.284-1.266 0l-4.476-4.453c-.012-.015-.012-.033-.024-.047-.307-.387-.28-.985 0-1.266l3.868-3.82z",
  fill: "#000"
}));